import React from "react";
import { Box } from "@material-ui/core";
import { CustomStepper } from "../../../../Components";
import { useIsDesktop } from "../../../../Hooks";

function AddRotationStepper({ stepperSchema, activeStep }) {
  const { isDesktop } = useIsDesktop();
  let stepLabels = stepperSchema.steps.map(({ stepLabel }) => stepLabel);

  if (!isDesktop)
    stepLabels = stepLabels.filter(
      (_, index) => index === activeStep + 1 || activeStep === index
    );

  return (
    <Box>
      <CustomStepper steps={stepLabels} activeStep={activeStep} />
    </Box>
  );
}

export default AddRotationStepper;
